<template>
  <transition name="toast-bounce">
    <div class="toast" v-show="visible">
      <div class="icon">
        <i class="iconfont icon-jingtan"></i>
      </div>
      <p class="message">{{ message }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      default: '默认信息'
    }
  }
}
</script>

<style lang="stylus" scoped>
.toast-bounce-enter, .toast-bounce-enter 
  opacity: 0
.toast
  position: fixed
  top: 1.9rem
  left: 50%
  transform: translateX(-50%)
  box-sizing: border-box
  padding: 0.2rem
  width: 2.3rem
  min-height: 1.1rem
  border-radius: 0.06rem
  background-color: rgba(0,0,0,0.4)
  color: #fff
  .icon
    margin-bottom: 0.1rem
    height: 0.3rem
    text-align: center
    .iconfont
      font-size: 0.3rem
  .message
    margin: auto
    width: 80%
    min-height: 1em
    font-weight: 500
    text-align: center
</style>


